import { CCONFERENCE_ROUTES } from './pages/ConfernceAndSchool/conference.routing';
// import { ConferenceComponent } from '../app/pages/ConfernceAndSchool/conference/Component/conference.component';
import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthenticateComponent } from './pages/authenticate/authenticate.component';
import { CommingSoonComponent } from './pages/comming-soon/comming-soon.component';
import { SchoolComponent } from './pages/ConfernceAndSchool/school/Component/school.component';
import { ConferenceComponent } from './pages/ConfernceAndSchool/conference/Component/conference.component';

export const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'about-us',
    loadComponent: () =>
      import('./pages/about-us/Component/about-us.component').then(
        (m) => m.AboutUsComponent,
      ),
  },
  {
    path: 'branch',
    loadComponent: () =>
      import('./pages/esrnm-branch/Component/esrnm-branch.component').then(
        (m) => m.EsrnmBranchComponent,
      ),
  },
  {
    path: 'doctor-details/:id',
    loadComponent: () =>
      import('./pages/doctor-details/Component/doctor-details.component').then(
        (m) => m.DoctorDetailsComponent,
      ),
  },
  // {
  //   path: 'memberShip',
  //   canActivate: [AuthGuard],
  //   loadComponent: () =>
  //     import('./pages/membership-old/Component/membership.component').then(
  //       (m) => m.MembershipComponent,
  //     ),
  // },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./pages/contact-us/Component/contact-us.component').then(
        (m) => m.ContactUsComponents,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/Components/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/components/register.component').then(
        (m) => m.RegisterComponent,
      ),
  },
  {
    path: 'forget-password',
    loadComponent: () =>
      import('./pages/forget-password/Components/forgetPassword.component').then(
        (m) => m.ForgetPasswordComponent,
      ),
  },
  {
    path: 'changePassword',
    loadComponent: () =>
      import('./pages/change-password/Components/changePassword.component').then(
        (m) => m.ChangePasswordComponent,
      ),
  },
  {
    path: 'resetPassword',
    loadComponent: () =>
      import('./pages/reset-password/Components/resetPassword.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/my-account/profile-page-routing.module').then(
        (m) => m.ProfilePageRoutingModule
      ),
  },
  {
    path: 'token-receiver',
    loadComponent: () =>
      import('./pages/token-receiver/token-receiver.component').then(
        (m) => m.TokenReceiverComponent
      ),
  },
  {
    path: 'verify/:email',
    loadComponent: () =>
      import('./pages/verify/Component/verify.component').then(
        (m) => m.VerifyComponent
      ),
  },
  {
    path: 'authenticate',
    component: AuthenticateComponent
  },

  {
    path: 'conferences',
    loadComponent: () =>
      import('./pages/ConfernceAndSchool/conference/Component/conference.component').then(
        (m) => m.ConferenceComponent
      ),
  },

  {
    path: 'Courses-and-Education',
    loadComponent: () =>
      import('./pages/ConfernceAndSchool/school/Component/school.component').then(
        (m) => m.SchoolComponent
      ),
  },

  {
    path: 'articles',
    loadComponent: () =>
      import('./pages/blog/blogs/blogs.component').then(
        (m) => m.BlogsComponent,
      ),
  },
  {
    path: 'article-details/:id',
    loadComponent: () =>
      import('./pages/blog/blog-details/blog-details.component').then(
        (m) => m.BlogDetailsComponent,
      ),
  },

  {
    path: 'news',
    loadComponent: () =>
      import('./pages/news/Components/news.component').then(
        (m) => m.NewsComponent,
      ),
  },
  {
    path: 'new-details/:id',
    loadComponent: () =>
      import('./pages/news-details/Components/news-details.component').then(
        (m) => m.NewsDetailsComponent,
      ),
  },
  {
    path: 'sponser-details/:id',
    loadComponent: () =>
      import('./pages/sponser/Components/sponser.component').then(
        (m) => m.SponserComponent,
      ),
  },
  {
    path: 'sub-specialized-society-details/:id',
    loadComponent: () =>
      import('./pages/Sub-associations/Components/sub-associations.component').then(
        (m) => m.SubAssociationsComponent,
      ),
  },

  ...CCONFERENCE_ROUTES,

  {
    path: '**',
    component: NotFoundComponent,
  },

];
